'use strict';

const postMessageType = 'themeChange';
const ATTR_NAME = 'data-theme';
const sendThemeChangedPostMessage = (windowForPostMessage, theme, domain) => {
    if (typeof windowForPostMessage.postMessage === 'undefined')
        return;
    windowForPostMessage.postMessage({ type: postMessageType, value: theme }, domain || '*');
};

exports.ATTR_NAME = ATTR_NAME;
exports.postMessageType = postMessageType;
exports.sendThemeChangedPostMessage = sendThemeChangedPostMessage;
//# sourceMappingURL=theme.js.map
